// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    apiKey: 'AIzaSyC59NZD1Vyg_wYRRXTmWYAP9C491VT_mRU',
    authDomain: 'socialnetworkforfriends.firebaseapp.com',
    projectId: 'socialnetworkforfriends',
    storageBucket: 'gs://socialnetworkforfriends.appspot.com',
    messagingSenderId: '506098669703',
    appId: '1:506098669703:web:d35ad68ae796b3b95a4022',
    measurementId: 'G-7DMPBESRGR',
  },
  recaptcha: {
    siteKey: '6LcI4EkkAAAAAM5IXYpQajGH_R118naEg40uBgaP',
  },
  production: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
